import { Component, Input, computed } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { JjamesButtonComponent, JJamesInputComponent, ResponsiveBaseComponent } from "shared-lib";
import { RegisteredParkerDto } from '../../../api/gen';

import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-general-account',
  imports: [CommonModule, MatIconModule, JjamesButtonComponent, JJamesInputComponent, TranslatePipe],
  templateUrl: './general-account.component.html',
  styleUrl: './general-account.component.scss'
})
export class GeneralAccountComponent extends ResponsiveBaseComponent {

  @Input() accountData: RegisteredParkerDto | null = null;

  /** When true, name/email are shown as static text and the edit affordances are hidden (JKU SSO identity). */
  @Input() readOnly = false;

  readonly fullName = computed(() => {
    const data = this.accountData;
    if (!data) return '';
    return [data.firstName, data.lastName].filter(Boolean).join(' ') || '—';
  });

  readonly email = computed(() => this.accountData?.email ?? '—');
}
